'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);

var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');

var onRenderPromotionDone = function(response) {

	appDom.topBody.append(response);

};

var onCustomLinkClick = function() {

	var $link = $(this);
	var promoLinkId = $link.attr('data-promo-link');

	triggerCustomEvent('promo-custom-link-clicked', {
		target: appDom.promo
	});

	if (promoLinkId) {

		$.ajax({
			url: '?promotions=promotion.renderPromotion',
			method: 'POST',
			dataType: 'html',
			data: {
				'promotionId': promoLinkId,
				'provideIframe': true
			}
		}).done(onRenderPromotionDone);

	}

};

var init = function() {

	appDom.promo.on('click', '.promo__custom-link', onCustomLinkClick);

};

module.exports = {
	init: init
};
